import TPL_list_box from '../list_box.tpl';
import { STR } from '../../../../utils/str';
import { ListBoxItemView } from './listBoxItem.view';
import { LOG } from '../../../../utils/log';
import { i18n } from '../../../../i18n';

export var ListBoxView = Backbone.View.extend({

  /**
   * Number of Display ligne
   */
  size: 5,

  /**
   * Number max of display line
   */
  maxSize: 6,
  /**
   * Number min of display line
   */
  minSize: 3,

  width: "250px",

  /**
   * Display search input on the top of <div>
   */
  search: false,

  initialize: function(options) {
    this.template = TPL_list_box;
    this.HEIGHT_INPUT = 24;
    this.model = null;
    this.enum = null;
    // Must be a ListBoxModel
    if (options.model) {
      this.model = options.model;
    } else if (options.enum) {
      this.enum = options.enum;
      this.nbLine = this.enum.length;
    } else {
      throw new Error(('ListBox must be insitialise with model or enum'));
    }

    this.isSelectAll = false;

    if (options) {
      if (options.workflow) {
        this.workflow = options.workflow;
      }
      if (options.id) {
        this.id = options.id;
      }
      if (options.multiValue) {
        this.multiValue = options.multiValue;
      }
      if (options.maxSize) {
        this.maxSize = options.maxSize;
      }
      if (options.minSize) {
        this.minSize = options.minSize;
      }
      if (options.size) {
        this.size = options.size;
      }

      if (options.search) {
        this.search = options.search;
      }
      if (options.name) {
        this.name = options.name;
      }
      if (options.width) {
        this.width = options.width;
      }
      if (options.default) {
        this.default = options.default;
        if (this.default.length > 0 &&  this.default[0].toUpperCase() === "tout".toUpperCase()) {
          this.isSelectAll = true;
        }
      }
      if (options.width) {
        this.width = options.width;
      }

    }
    /** 
     * Height = nb of line * size of one line
     */
    this.height = (this.size * this.HEIGHT_INPUT);

    if (this.nbLine < this.maxSize) {
      this.maxSize = this.nbLine;
    }

    this.isActivSearch = false;
    this.first = true;

  },
  events: {
    'click .ui-icon-search': '_displaySearch',
    'click .ui-icon-plus': '_addLine',
    'click .ui-icon-minus': '_removeLine',
    'keyup .list-box-search': '_startSearch',
    'change input': '_changeInput',
    'click li': '_selectLi',
    'click .select-all': '_selectAll',
    'click .phx-list-box.is-select-all': '_disabledListener'
  },

  render: function() {
    var json = {
      'i18n': i18n,
    };
    var fields = this.getFields();
    $(this.el).html(this.template(json));
    $(this.el).find('.list-item-box').append(fields);

    if (!this.search) {
      $(this.el).find('#list-box-search').hide();
      $(this.el).find('.input-search').hide();
    }
    $(this.el).find('.phx-list-box').css('height', this.height);
    $(this.el).find('.list-item-box').css('height', this.height);

    $(this.el).find('.phx-list-box').css('width', this.width);

    if (this.size <= this.minSize) {
      $(this.el).find('.ui-icon-minus').hide();
    }
    if (this.size >= this.maxSize) {
      $(this.el).find('.ui-icon-plus').hide();
    }

    if (this.isSelectAll) {
      $(this.el).find('.select-all').attr('checked', 'checked');
      $(this.el).find('.phx-list-box').addClass('is-select-all');

    }

    return this;

  },

  getFields: function() {
    var fields = "";
    if (!STR.isNull(this.enum)) {
      for (var index = 0; index < this.enum.length; index++) {

        var checked = (!STR.isUndefined(this.default) && !STR.isNull(this.default) && this.default.indexOf(this.enum[index].code) !== -1);

        var field = new ListBoxItemView({
          value: this.enum[index],
          name: this.name,
          checked: checked,
        });
        fields += field.render().$el.html();
      }
      return fields;
    }
    return null;
  },

  _changeInput: function(event) {

    var target = $(event.target);
    var id = target.attr('id');
    var parent = target.parent();
    LOG.debug('Input Change : ' + id);

    if (target.hasClass('select-all')) {
      this.$el.find('ul.list-item-box li.select').removeClass('select');
      if (target.prop('checked')) {
        this.$el.find('.phx-list-box').addClass('is-select-all');
        this.$el.find('input.list-box-search').hide();

        var values = this.getValueToArray(true);
        this.workflow.model.set("value", values);

        this.isSelectAll = true;
      } else {
        this.$el.find('.phx-list-box').removeClass('is-select-all');
        var listValues = this.$el.find('input.phx-list-box-item:checked');
        for(var index = 0 ; index < listValues.length ; index++){
          $(listValues[index]).removeAttr('checked');
        }
        this.workflow.model.set("value", []);

        this.isSelectAll = false;
      }
    } else {
      if (target.prop('checked')) {
        parent.addClass('select');
        target.attr('data-select', 'select');
      } else {
        parent.removeClass('select');
        target.removeAttr('data-select');
      }

      if (target.hasClass("list-box-search")) {
        this._startSearch(event);
      }
    }
  },

  _displaySearch: function(event) {
    if (!this.isSelectAll) {
      var target = $(event.target);
      var fieldSearch = this.$el.find('input.list-box-search');

      var state = target.attr('data-state') === "true";

      if (state) {
        fieldSearch.hide();
        target.attr('data-state', 'false');
        this.isActivSearch = false;
        this.first = true;
        if (this.size > this.minSize) {
          this.size--;
        }
      } else {
        fieldSearch.show();
        target.attr('data-state', 'true');
        this.isActivSearch = true;
        this.first = true;
        this.size++;

      }

      this.height = (this.size * this.HEIGHT_INPUT);
      this.$el.find('.phx-list-box').css('height', this.height);
      this.$el.find('.list-item-box').css('height', this.height);
    }
  },

  _startSearch: function(event) {
    var target = $(event.target);
    var parent = target.parent();

    var search = new RegExp(target.val(), 'gi');
    var listLi = parent.children('ul').find('li');

    for (var index = 0; index < listLi.length; index++) {
      var li = $(listLi[index]);
      if (li.text().trim().match(search)) {
        li.show();
      } else {
        li.hide();
      }
    }
  },

  getValueToArray: function(all) {
    var listValues = null;

    if (!STR.isUndefined(all) && all) {
      listValues = this.$el.find('input.phx-list-box-item');
    } else {
      listValues = this.$el.find('input.phx-list-box-item:checked');
    }

    var val = [];
    if (listValues.length > 0) {
      for (var index = 0; index < listValues.length; index++) {
        var el = listValues[index];
        val.push(($(el).val()));
      }
    }

    return val;
  },

  _selectLi: function(event) {
    $(event.target).find('input').click();
  },

  _addLine: function(event) {

    var target = $(event.target);

    if (this.size < this.maxSize) {
      if (this.isActivSearch && this.first) {
        this.first = false;
      } else {
        this.size++;
      }
      this.height = (this.size * this.HEIGHT_INPUT);
      this.$el.find('.phx-list-box').css('height', this.height);
      this.$el.find('.list-item-box').css('height', this.height);

      // Show icone minus    
      this.$el.find('.ui-icon-minus').show();
    }
    if (this.size >= this.maxSize) {
      target.hide()
    }
  },

  _removeLine: function(event) {
    var target = $(event.target);
    if (this.size > this.minSize) {
      if (!this.isActivSearch && this.first) {
        this.first = false;
      } else {
        this.size--;
      }
      this.height = (this.size * this.HEIGHT_INPUT);
      this.$el.find('.phx-list-box').css('height', this.height);
      this.$el.find('.list-item-box').css('height', this.height);

      // Show icone minus    
      this.$el.find('.ui-icon-plus').show();
    }

    if (this.size <= this.minSize) {
      target.hide();
    }
  },

  _disabledListener: function(event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  },

  addTitleLabel: function() {
    var listLi = this.$el.find('ul.list-item-box li');
    for (var index = 0; index < listLi.length; index++) {
      var li = listLi[index];
      if (li.children[1].scrollWidth > 250) {
        $(li).find('label').attr('title', $(li).find('label').text().trim());
      }
    }
  },
});
